import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PorangeButton } from "@/components/atoms/PorangeButton";

export const Statement = ({ onAnswer }) => {
    const [isExiting, setIsExiting] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [activePractice, setActivePractice] = useState(0);
    
    const safetyPractices = [
        {
            icon: '🧤',
            label: 'Dedicated Prep',
            detail: 'Separate cooking areas'
        },
        {
            icon: '🧼',
            label: 'Clean Practices',
            detail: 'Strict protocols followed'
        },
        {
            icon: '👨‍🍳',
            label: 'Trained Staff',
            detail: 'GF-aware kitchen team'
        },
        {
            icon: '✅',
            label: 'Verified Safe',
            detail: 'Community confirmed'
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setActivePractice(current => (current + 1) % safetyPractices.length);
        }, 2000);
        
        setTimeout(() => setShowButton(true), 1000);
        return () => clearInterval(interval);
    }, []);

    const handleContinue = () => {
        setShowButton(false);
        setTimeout(() => {
            setIsExiting(true);
            setTimeout(() => onAnswer('continue'), 800);
        }, 400);
    };

    return (
        <div 
            className={classNames(
                "relative h-full flex flex-col items-center justify-start px-6",
                "transition-all duration-500 ease-in-out",
                isExiting 
                    ? "opacity-0 transform translate-y-10" 
                    : "opacity-100 transform translate-y-0"
            )}
        >
            <div className="text-center space-y-4 max-w-[600px] mt-[48px]">
                <h2 className="text-[28px] md:text-[36px] leading-tight font-bold text-black">
                    We verify{' '}
                    <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                        kitchen safety
                    </span>
                </h2>
            </div>

            <div className="flex-1 flex items-center justify-center w-full">
                <div className="grid grid-cols-2 gap-4 w-full max-w-[400px]">
                    {safetyPractices.map((practice, index) => (
                        <div 
                            key={index}
                            className={classNames(
                                "flex flex-col items-center text-center p-6 rounded-xl transition-all duration-500",
                                activePractice === index 
                                    ? "bg-white shadow-lg scale-105" 
                                    : "bg-gray-50"
                            )}
                        >
                            <div className="text-4xl mb-3">{practice.icon}</div>
                            <div className="font-semibold text-gray-800 mb-1">
                                {practice.label}
                            </div>
                            <div className="text-sm text-gray-600">
                                {practice.detail}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="text-center text-gray-600 text-sm px-6 mb-4">
                Ensuring safe gluten-free preparation
            </div>

            <div 
                className={classNames(
                    "fixed bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-white via-white to-transparent pb-6 pt-10",
                    "transition-all duration-500",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
                )}
            >
                <PorangeButton
                    full={true}
                    className="h-[56px] rounded-[16px] text-lg shadow-md"
                    onClick={handleContinue}
                >
                    Continue
                </PorangeButton>
            </div>
        </div>
    );
};

export default Statement; 